import { render, staticRenderFns } from "./newsgetone.vue?vue&type=template&id=6dd4cdb8&scoped=true&"
import script from "./newsgetone.vue?vue&type=script&lang=js&"
export * from "./newsgetone.vue?vue&type=script&lang=js&"
import style0 from "./newsgetone.vue?vue&type=style&index=0&id=6dd4cdb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd4cdb8",
  null
  
)

export default component.exports